import { apiClient } from "./client";

// ============================================================================
// I file caricati (/uploads/...) ora richiedono autenticazione lato server:
// non si possono più mettere direttamente in <img src> o <a href>, perché il
// browser non allegherebbe il token JWT a quelle richieste. Qui li scarichiamo
// via apiClient (che aggiunge il token) come blob, e ne creiamo un object URL
// utilizzabile per mostrarli o scaricarli.
//
// baseURL: "" perché i file stanno su /uploads, non sotto /api — l'interceptor
// che allega il token resta comunque attivo.
// ============================================================================

export async function fetchProtectedBlob(fileUrl: string): Promise<Blob> {
  const res = await apiClient.get<Blob>(fileUrl, { baseURL: "", responseType: "blob" });
  return res.data;
}

/** Scarica un file protetto forzando il "save as" del browser. */
export async function downloadProtectedFile(fileUrl: string, filename: string): Promise<void> {
  const blob = await fetchProtectedBlob(fileUrl);
  const objectUrl = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = objectUrl;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(objectUrl);
}
